import { ClassFlag } from "../dom-tools/ClassFlag";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType } from "../dom-tools/ElementType";
import { HTMLEditor } from "../dom-tools/HTMLEditor";
import { RegExpUtility } from "../text/RegExpUtility";
import { OnClick } from "../../library-js/dom-tools/EventListeners";

export class PointCounter
{
  static readonly attribute  = new ElementAttribute( "point--counter" );
  static readonly pointIndexFormula = new ElementAttribute( "point--index--formula" );  
  static readonly pointIndex = new ElementType( "point--index" );

  static readonly formulaIndexVariable = "{{index}}";
  static readonly defaultIndexFormula = `${PointCounter.formulaIndexVariable}.`;
  static readonly minimumDigits = new ElementAttribute( "minimum-digits");

  

  static applyOnDocument()
  {
    PointCounter.attribute.forEachInDoc( e => PointCounter.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let points = PointCounter.attribute.queryValueAllIn( e );
    let formula = PointCounter.pointIndexFormula.from( e, PointCounter.defaultIndexFormula );
    let minimumDigits = PointCounter.minimumDigits.asNumberFrom( e, 0 );


    let setActivePoint = ( index:number ) => 
    {
      for ( let i = 0; i < points.length; i++ )
      {
        let pointIndex = PointCounter.pointIndex.query( points[ i ] );

        if ( i !== index )
        {
          ClassFlag.active.setAs( pointIndex, i === index );
        }
        else
        {
          ClassFlag.active.toggle( pointIndex );
        }

        
      }
    };

    for ( let i = 0; i < points.length; i++ )
    {
      let numberValue = RegExpUtility.minimumDigitsInt( i + 1, minimumDigits );
      let indexValue = formula.replace( PointCounter.formulaIndexVariable, numberValue );

      let pointIndex = PointCounter.pointIndex.query( points[ i ] );

      if ( ! pointIndex )
      {
        pointIndex = PointCounter.pointIndex.create();
        HTMLEditor.addOnStart( points[ i ], pointIndex );
      }

      pointIndex.innerHTML = indexValue;
      
      OnClick.add( pointIndex as HTMLElement, () => { setActivePoint( i ); }  );



    }
  }
}